import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import { useTheme } from "../../../context/ThemeContext";
import { setupSteps } from "../../data/setupSteps";

function NtSetupWelcomeStep() {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  // Skip the welcome step itself when listing what's coming up.
  const upcoming = setupSteps.slice(1);

  return (
    <View>
      <NtText style={styles.sectionLabel}>What you'll set up</NtText>
      <View style={styles.list}>
        {upcoming.map((step, index) => {
          const featured = step.key === "assistant";
          return (
            <View
              key={step.key}
              style={[styles.row, featured && styles.rowFeatured]}
            >
              <View style={[styles.num, featured && styles.numFeatured]}>
                <NtText
                  style={[styles.numText, featured && styles.numTextFeatured]}
                >
                  {index + 1}
                </NtText>
              </View>
              <View style={styles.rowMid}>
                <View style={styles.rowTitleLine}>
                  <NtText
                    style={[
                      styles.rowTitle,
                      featured && styles.rowTitleFeatured,
                    ]}
                  >
                    {step.title}
                  </NtText>
                  {featured ? (
                    <View style={styles.featuredBadge}>
                      <NtText style={styles.featuredBadgeText}>
                        RECOMMENDED
                      </NtText>
                    </View>
                  ) : null}
                </View>
                {featured ? (
                  <NtText style={styles.rowSub}>
                    Tell us about your business and we'll propose extensions,
                    ring groups, and an auto-attendant in one shot.
                  </NtText>
                ) : null}
              </View>
              <NtMaterialIcon
                name={step.icon}
                size={18}
                color={featured ? theme.brand2 : theme.textDim}
              />
            </View>
          );
        })}
      </View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    sectionLabel: {
      fontSize: 11,
      fontWeight: "700",
      color: t.textMute,
      textTransform: "uppercase",
      letterSpacing: 0.6,
      marginBottom: 14,
    },
    list: {
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.border,
      borderRadius: t.radiusCard,
      overflow: "hidden",
      maxWidth: 720,
    },
    row: {
      flexDirection: "row",
      alignItems: "center",
      gap: 14,
      paddingVertical: 14,
      paddingHorizontal: 18,
      borderBottomWidth: 1,
      borderBottomColor: t.borderSoft,
    },
    num: {
      width: 28,
      height: 28,
      borderRadius: 14,
      backgroundColor: t.pillBg,
      borderWidth: 1,
      borderColor: t.pillBorder,
      alignItems: "center",
      justifyContent: "center",
    },
    numFeatured: { backgroundColor: t.brand2, borderColor: t.brand2 },
    numText: { fontSize: 12, fontWeight: "700", color: t.brand2 },
    numTextFeatured: { color: "#fff" },
    rowMid: { flex: 1 },
    rowTitleLine: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
      flexWrap: "wrap",
    },
    rowTitle: { fontSize: 14, color: t.text, fontWeight: "600" },
    rowTitleFeatured: { color: t.text },
    rowSub: {
      fontSize: 12,
      color: t.textDim,
      marginTop: 3,
      lineHeight: 17,
    },
    rowFeatured: {
      borderLeftWidth: 3,
      borderLeftColor: t.brand2,
    },
    featuredBadge: {
      backgroundColor: t.brand2,
      paddingHorizontal: 7,
      paddingVertical: 2,
      borderRadius: 999,
    },
    featuredBadgeText: {
      color: "#fff",
      fontSize: 9,
      fontWeight: "700",
      letterSpacing: 0.6,
    },
  });

export default NtSetupWelcomeStep;
